import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import NavPanel from '@/components/common/NavPanel.vue';
import { Options } from 'vue-class-component';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    View_1 = View;
    Object.defineProperty(View.prototype, "alertPayImgUrl", {
        get: function () {
            var _a;
            var pkg = (_a = this.awlGlobalState.urlInitParams) === null || _a === void 0 ? void 0 : _a.package;
            var imgName = pkg && pkg !== 'undefined' && View_1.NOTICE_IMG_PACKAGES.has(pkg) ? pkg : 'aimi';
            var imgUrl = "activity/CleanNetAction/" + imgName + ".png";
            return this.awlGlobalConfig.getH5ImgUrl(imgUrl);
        },
        enumerable: false,
        configurable: true
    });
    var View_1;
    /** 有独立净网行动图的包体；后续新增包体在此追加即可，未命中回落 aimi */
    View.NOTICE_IMG_PACKAGES = new Set(['huanxun', 'aimi']);
    View = View_1 = __decorate([
        Options({
            components: { NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
